module.exports = __webpack_public_path__ + "img/icon-seta.d66a08bd.svg";